import { GreyGrey30, Flex } from '@sequencehq/core-components'
import { PdfPreview } from './previews'
import { useLayoutEffect, useRef } from 'react'
import { useSetAtom } from 'jotai'
import { previewContainerRefAtom } from './preview.atoms'

export const Preview = () => {
  const previewContainerRef = useRef<HTMLDivElement | null>(null)
  const setPreviewContainerRef = useSetAtom(previewContainerRefAtom)

  useLayoutEffect(() => {
    setPreviewContainerRef(previewContainerRef.current)
  }, [setPreviewContainerRef])

  return (
    <Flex
      ref={previewContainerRef}
      data-testid="invoicePreview"
      borderLeft={`${GreyGrey30} 1px solid`}
      flexDir="column"
      width="100%"
      gap={{ base: '24px', '2xl': '32px' }}
      padding={{ base: '24px', '2xl': '32px' }}
      overflow="auto"
    >
      <PdfPreview />
    </Flex>
  )
}
